import { kmm } from './kmm';
import { KtList } from '@norlys-a-s/norlys-play-kmm';

export interface FavoritesList {
  id: number;
  name: string;
  sids: number[];
}

export async function saveCustomerFavList(favoritesList: FavoritesList): Promise<boolean> {
  const { id, name, sids } = favoritesList;
  const sidsKtList = KtList.fromJsArray(sids);
  return kmm((repo) => repo.saveCustomerFavList(id, name, sidsKtList));
}

export default saveCustomerFavList;
